import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { customInputEndpoint } from "@/config/endpoints";
import { getCfDisplayName } from "@/features/customField/utils/cfDisplayName";

export default function useCustomInputs() {
  const query = useQuery({
    queryKey: ["connections"],
    queryFn: async () => {
      const res = await axiosInstance.get(customInputEndpoint);
      return res.data.inputs;
    },
  });

  // Selects are display artifacts — user label wins. Raw `connections`
  // keeps the untouched rows for identity/matching consumers.
  const connectionSelects =
    query.data?.map((val: any) => ({
      value: String(val.id),
      name: getCfDisplayName(val),
    })) ?? [];

  return {
    connections: query.data,
    connectionSelects,
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
